import React from 'react';
import {makeStyles, Container, Grid, Paper, Dialog, AppBar, Toolbar, Slide, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import ViewLeaveForm from '../../LeaveApplication/component/Form'
import Balance from '../../LeaveApplication/component/Balance'
import RecentLeave from '../../LeaveApplication/component/RecentLeave'
import RecentLeaveCollection from '../../Function/RecentLeaveCollection'
import customAxios from "../../../components/API/customAxios";
import Details from "../../MyLeave/component/Details"
import {useIntl} from 'react-intl';
import {useHistory} from "react-router-dom";
import {checkUndefined} from "../../Function/globalFunction";
import MiniTable from "../../UIComponent/MiniTable";
import CompLeaveCollection from "../../Function/CompLeaveCollection";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function View({handleClose, open, showId, backToTable, isNewCompLeave, pageClose}) {
    const mode = window.global.viewMode;
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);
    const [employeeDuty, setEmployeeDuty] = React.useState('');
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showDetail, setShowDetail] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [isApprover, setIsApprover] = React.useState(false);
    const [approveId, setApproveId] = React.useState('');
    const page = isNewCompLeave ? 'View Comp Leave' : 'View Leave';
    const hrAdmin = localStorage.getItem('isHRAdminOpen');

    React.useEffect(() => {
        customAxios.get(`/get_team_leave/${showId}?isNewCompLeave=${isNewCompLeave}&isHrView=${hrAdmin}`)
            .then(res => {
                if (String(res.data.status) !== window.global.withdrawn) {
                    setShowDetail(true);
                } else {
                    setShowDetail(false);
                }

                if (res.data.is_approver === true) {
                    setIsApprover(true);
                    setApproveId(res.data.processing_application_id);
                } else {
                    setIsApprover(false);
                    setApproveId('');
                }

                setApplication(res.data);
                setRows(RecentLeaveCollection(res.data['recent_leave'], intl));
                setShowCompetent(true);
                setCompLeaveRows(CompLeaveCollection(res.data['comp_leave_balance'], intl));
                setEmployeeDuty(res.data['staff_duty'])
            }).catch(error => {
            console.error(error);
            history.push('/home');
        })
    }, []);

    const handlePageClose = () => {
        window.close();
    };

    return (
        <Dialog fullScreen open={open} onClose={pageClose ? handlePageClose : handleClose} TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: '#f0f2f5',
                        boxShadow: 'none',
                    },
                }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={pageClose ? handlePageClose : handleClose} aria-label="close">
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container className={classes.container}>
                {showCompetent ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={7}>
                            <Paper className={classes.mainPaper}>
                                <ViewLeaveForm
                                    mode={mode}
                                    employeeId={application.employee.id}
                                    employeeName={application.employee.employee_name}
                                    staffDuty={application.employee.staff_duty}
                                    annualAllowances={application.employee.annual_allowances}
                                    annualTotal={application.employee.annual_total}
                                    editApplicationId={application.id}
                                    editTypeId={application.type_id}
                                    editTypeName={intl.formatMessage({id: 'guideline.' + application.type.name})}
                                    editStartDate={application.start_date}
                                    editStartTime={application.start_time}
                                    editUntilDate={application.until_date}
                                    editEndTime={application.end_time}
                                    editPeriod={application.period}
                                    editReason={checkUndefined(application.reason)}
                                    editAttachment={application.attachment}
                                    editAttachmentPath={checkUndefined(application.attachment_path)}
                                    editStatus={application.status}
                                    editUpdatedAt={application.updated_at}
                                    editIsApprover={isApprover}
                                    approveId={approveId}
                                    approveMode={window.global.myTeamApprove}
                                    backToTable={backToTable}
                                    compLeaveRows={compLeaveRows}
                                    isNewCompLeave={isNewCompLeave}
                                    pageClose={pageClose}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={5}>
                            <Paper className={classes.subPaper}>
                                <Balance
                                    mode={mode}
                                    userRole={application.user_role}
                                    annualAllowances={application.employee.annual_allowances}
                                    sickAllowances={application.employee.sick_allowances}
                                />
                            </Paper>
                            {employeeDuty === 'OFFICE HOURS' ? (
                                <Paper className={classes.subPaper}>
                                    <MiniTable rows={compLeaveRows}/>
                                </Paper>
                            ) : ''}
                            {showDetail &&
                                <Paper className={classes.subPaper}>
                                    <Details 
                                        handleClose={null} 
                                        open={null} 
                                        showId={application.id} 
                                        page={page}
                                    />
                                </Paper>
                            }
                            <Paper className={classes.subPaper}>
                                <RecentLeave rows={rows}/>
                            </Paper>
                        </Grid>
                    </Grid>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress/>
                    </div>
                }
            </Container>
        </Dialog>
    )
}
